/* eslint-disable */
// This is a mock configuration file for local development
// In a real environment, this would be generated by AWS Amplify CLI

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:mock-identity-pool-id",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_mockUserPool",
    "aws_user_pools_web_client_id": "mock-client-id",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "api",
            "endpoint": "http://localhost:3001/api",
            "region": "us-east-1"
        }
    ]
};

export default awsmobile;
